/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosSessionStatsDto } from '../../models/pos-session-stats-dto';

export interface PosSessionsControllerGetStats$Params {
  id: string;
}

export function posSessionsControllerGetStats(http: HttpClient, rootUrl: string, params: PosSessionsControllerGetStats$Params, context?: HttpContext): Observable<StrictHttpResponse<PosSessionStatsDto>> {
  const rb = new RequestBuilder(rootUrl, posSessionsControllerGetStats.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosSessionStatsDto>;
    })
  );
}

posSessionsControllerGetStats.PATH = '/pos/sessions/{id}/stats';
